/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 16.06.17.
 */

import React from "react";
import PropTypes from "prop-types";
import DataProvider from "../../../DataProvider";
import {Link} from "react-router";
import _ from "underscore";
import {vsprintf} from 'sprintf-js';
import ViewText from "./ViewText";
import {SessionStore} from "../../../services/Session";

/**
 * Used for displaying links to other resources.
 * Specify in UI Schema as follows:
 *  {
 *      "ui:widget": "link",
 *      "ui:options": {
 *          "linkUrl": [urlSprintfStr, fieldName...]
 *      }
 *  }
 */
class ViewLink extends React.Component {
    static propTypes = {
        dataProvider: PropTypes.instanceOf(DataProvider).isRequired,
        field: PropTypes.string.isRequired
    };

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {};
    }

    getLinkUrl() {
        let dataProvider = this.props.dataProvider;
        let schema = dataProvider.getSchema();
        let options = schema.field(this.props.field).getSchemaElement("options");
        let url = options.linkUrl;
        if (_.isArray(url)) {
            let format = url[0];
            let params = _.map(url.slice(1), function (item) {
                return dataProvider.getValue(item);
            });
            url = vsprintf(url[0], params);
        }
        return url;
    }

    render() {
        let linkUrl = this.getLinkUrl();
        if (SessionStore.isAuthorized(linkUrl)) {
            return (
                <Link to={linkUrl}>
                    <ViewText dataProvider={this.props.dataProvider} field={this.props.field}/>
                </Link>
            );

        } else {
            return (
                <ViewText dataProvider={this.props.dataProvider} field={this.props.field}/>
            );
        }
    }
}

export default ViewLink;
